import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.7501 22.6309L4.04297 13.9238L5.45718 12.5095L11.7501 18.8024L11.7501 2.21665H13.7501V18.8024L20.043 12.5095L21.4572 13.9238L12.7501 22.6309Z",
		fill: "#395566"
	})
});
export default SvgLine;
